export default "__VITE_ASSET__3026bf99__"